import './Menu.less';
import React, {useState, useEffect} from 'react';
import ChapterItem from "./chapter-item/ChapterItem";
import LessonList from "./lesson-list/LessonList";


export default function Menu({chapters, lessons, currentLessonId}) {

    return <div className="menu">
        {
            chapters.length > 0 &&
            <ul className="season-list">
                {
                    chapters.map(chapter => <ChapterItem
                        key={chapter.id}
                        chapter={chapter}
                        lessons={lessons.filter(t => t.chapter_id === chapter.id)}
                        currentLessonId={currentLessonId}
                    />)
                }
            </ul>
        }
        {
            lessons.some(lesson => lesson.chapter_id === null) &&
            <LessonList
                lessons={lessons.filter(t => t.chapter_id === null)}
                currentLessonId={currentLessonId}
            />
        }
    </div>;
}
